import {IPayment} from '../../../coreGlobal/models/paymentOption'
import {SplitInfoCartao} from './SplitInfoCartao'
import {SplitInfoCartaoRecorrente} from './SplitInfoCartaoRecorrente'
import {SplitInfoPix} from './SplitInfoPix'

interface ISplit {
  payment: IPayment[]
}

const SwitchMethod = ({pay}: {pay: IPayment}) => {
  if (pay.value === 0) return <></>

  switch (Number(pay.method)) {
    case 1:
      return <SplitInfoPix value={pay.value} date={new Date()} />
    case 2:
      return (
        <SplitInfoCartao
          value={pay.value}
          date={new Date()}
          installments={pay.numberOfInstallments}
        />
      )
    case 3:
      return (
        <SplitInfoCartaoRecorrente
          value={pay.value}
          date={new Date()}
          installments={pay.numberOfInstallments}
        />
      )

    default:
      return <></>
  }
}

export const SplitPayment = ({payment}: ISplit) => {
  return (
    <div className='col-12'>
      {payment?.map((pay: IPayment, index: number) => {
        return <SwitchMethod key={pay.paymentRef} pay={pay} />
      })}
    </div>
  )
}
